import React, { useEffect, useState } from 'react'
import { ChangePassword, ModalComponent } from '@qure/containers'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import onLogout from 'libs/onLogout'
import getFormattedErrorCode from 'libs/getFormattedErrorCode'

import utils from './utils'
import changePasswordService from './services'

const ChangePasswordModal = props => {
  const { isAdmin, onClose, userEmail, userName, isOpen } = props
  const [isMewPasswordInProgress, setNewPasswordInProgress] = useState(false)
  const [isNewPasswordComplete, setNewPasswordComplete] = useState(false)
  const [createPasswordErrorMessage, setCreatePasswordErrorMessage] = useState(
    null
  )
  const [isReset, setIsReset] = useState(false)

  /* eslint-disable */
  // const [isOpen, setIsOpen] = useState(props.isOpen)
  /* eslint-enable */
  const history = useHistory()
  const { t } = useTranslation()

  const onNewPasswordComplete = () => {}

  const callChangePasswordService = (formValues, isDeleteSession) => {
    const payload = utils.buildPayload(
      isAdmin,
      formValues,
      isDeleteSession || null,
      userEmail
    )
    changePasswordService(payload)
      .then(() => {
        setNewPasswordInProgress(false)
        setNewPasswordComplete(true)
      })
      .catch(err => {
        const error = _.get(err, ['response'])
        const errorMessage = _.get(error, ['data', 'error'])
        const { formatted: errorCode } = getFormattedErrorCode(err)

        /* eslint-disable */
        console.error(err)
        /* eslint-enable */
        setNewPasswordInProgress(false)
        setCreatePasswordErrorMessage(errorCode + t(errorMessage))
      })
  }
  const onLogoutSession = values => {
    callChangePasswordService(values, true)
    onLogout(history)
  }

  const onSubmit = values => {
    setNewPasswordInProgress(true)
    callChangePasswordService(values)
  }
  const defaultLabels = {
    newPasswordHeader: null,
    password: t('New password'),
    confirmPassword: t('Confirm new password'),
    currentPassword: t('Current password'),
    userEmail: t('User email'),
    resetPasswordButton: t('Change password'),
    passwordUpdated: {
      header: t('Password is updated'),
      subHeader: t('We have successfully updated your password')
    },
    passwordComplexity: {
      header: t('Password requirements'),
      minimumCharacters: t('minimum 8 characters'),
      upperCaseLetter: t('atleast 1 upper-case letter'),
      lowerCaseLetter: t('atleast 1 lower-case letter'),
      digit: t('atleast 1 digit')
    },
    fieldErrorMessages: {
      required: t('Required'),
      minLengthPassword: t('Must be at least 5 characters'),
      passwordComplexity: t('Does not match the password requirement'),
      bothPasswordMatch: t('Both passwords must match')
    }
  }
  const passwordHeaderObj = {
    newPasswordHeader: t('Username'),
    username: userName
  }
  const labels = isAdmin
    ? { ...defaultLabels, ...passwordHeaderObj }
    : defaultLabels

  useEffect(() => {
    setIsReset(!isReset)
    setCreatePasswordErrorMessage(null)
  }, [isOpen])

  return (
    <ModalComponent
      modalTitle={t('Change password')}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ChangePassword
        labels={labels}
        createPasswordErrorMessage={createPasswordErrorMessage}
        onNewPasswordSubmit={onSubmit}
        isNewPasswordComplete={isNewPasswordComplete}
        isMewPasswordInProgress={isMewPasswordInProgress}
        onNewPasswordComplete={onNewPasswordComplete}
        logoPath="/qTrackLogo.svg"
        isAdmin={isAdmin}
        onModalClose={onClose}
        onLogoutSession={onLogoutSession}
        isReset={isReset}
      />
    </ModalComponent>
  )
}

ChangePasswordModal.defaultProps = {
  userEmail: '',
  userName: ''
}

ChangePasswordModal.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  userEmail: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  userName: PropTypes.string
}

export default ChangePasswordModal
